import PropTypes from 'prop-types'
import React from 'react'
import Media from 'react-media'
import { connect } from 'transfer/utils/p2p-connect'
import { routeTo } from 'transfer/utils/routeHelper'
import { paymentTypeUrlMap } from '../../index'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from '../../../../../utils/unified-send-analytics'
import content from 'pp-react-l10n'

import { PaymentTypes } from '../alt-pay-styles'
import { SIZE_MOBILE } from 'lib/styles/media-queries'
import { mediaQueries } from 'transfer/styles'
import glamorous from 'glamorous'
import PurchaseProtection from '../../purchaseProtectionLink'

import * as UnifiedActions from 'transfer/actions/unified-actions'
import { redirectToDolphin } from '../../../../../actions/unified-actions'
import * as ViewActions from '../../../../../actions/Actions'
import { handleInterstitialCipFlow } from '../../../../../utils/homeInfoUtils'

import {
  SingleSelectionGroup,
  Button,
  BodyText,
  Spot,
  CaptionText,
  v2grey300,
} from '@paypalcorp/pp-react'

const { phoneLandscapeMax: phone640 } = mediaQueries
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')

const PaymentTypesToggle = glamorous(PaymentTypes)({
  textAlign: 'center',
  '& label': {
    [phone640]: {
      padding: '1rem',
    },
    padding: '2rem 1rem 2rem 1.5rem',
    textAlign: 'left',
    maxWidth: '28rem',
    WebkitTextStrokeWidth: 'initial',
    border: `1px solid ${v2grey300}`,
  },
  '& .send-type-goods-personal': {
    display: 'inline-flex',
  },
  '& .send-type-goods-personal > div': {
    display: 'flex',
    flexFlow: 'column',
  },
  '& .learnMore': {
    marginTop: '1.5rem',
    [phone640]: {
      marginTop: '1.25rem',
    },
  },
  '& .ctaButton': {
    marginTop: '2rem',
    [phone640]: {
      marginTop: '1rem',
      width: '19rem',
    },
  },
})

const TitleText = glamorous.div({
  marginBottom: '0.5rem',
})

const IconWrapper = glamorous.div({}, ({ isMobile = false }) => {
  return {
    margin: isMobile ? '0.5rem auto 1.25rem' : '0 auto 1.5rem',
  }
})

export class PaymentTypeChoice extends React.Component {
  // this function test if we are changing the previously chosen payment type
  determineLocation = () => {
    if (window.location.pathname.indexOf('send/preview') !== -1) {
      return ['personal', false]
    } else if (window.location.pathname.indexOf('buy/preview') !== -1) {
      return ['goods', true]
    }

    if (this.props.flowType === 'payRequest') {
      return this.props.isPurchase ? ['goods', true] : ['personal', false]
    }
    return [null, null]
  }

  state = {
    isPurchase: this.determineLocation()[1],
    radioValue: this.determineLocation()[0],
  }

  url = null
  targetFlowType = this.props.flowType

  // we route on unmount because if we route immediately after dispatching the action to close the overpanel,
  // it's too fast and the overpanel stays attached to the DOM.. so we let the overpanel unmounting do the routing
  componentWillUnmount() {
    // Redirect to Dolphin Flow After Payment Type Selection if the user has no confirmed phone and falls in the treatment
    const {
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      payerId,
      recipient,
      displayName,
      thumbnailUrl,
    } = this.props
    if (
      this.props.flowType !== 'payRequest' &&
      triggerSenderPhoneConfirmation
    ) {
      const flowType = this.targetFlowType
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      this.props.dispatch(redirectToDolphin(data))
    } else if (this.url && this.url !== 'payRequest') {
      routeTo(this.url)
    }
  }

  componentDidMount() {
    if (
      this.props.flowType === 'payRequest' &&
      this.props.paymentTypeIsSelected
    ) {
      return
    }

    let pathName = window.location.pathname
    if (
      pathName.indexOf('send/preview') === -1 &&
      pathName.indexOf('buy/preview') === -1
    ) {
      setTimeout(() => {
        this.startAnimation()
      }, 250)
    }
  }

  startAnimation() {
    this.setState({ isPurchase: true, radioValue: 'goods' })
  }

  handleCloseForOtherFlow = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.flowType === 'payRequest') {
      if (!this.props.paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = this.props.isPurchase ? 'buy' : 'send'
        if (preFlowType !== targetFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      shouldUpdateTransactionData = true
      this.targetFlowType = targetFlowType
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === 'send' ? 'guestSelectFF' : 'guestSelectGS'
      } else {
        pageAction = targetFlowType === 'send' ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)

      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === 'buy',
          changedPurchaseProtection: true,
        })
      )
      if (this.props.isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }
    }

    this.props.handleCloseForOtherFlow(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  handleSubmit = e => {
    let targetFlowType = this.state.isPurchase ? 'buy' : 'send'

    let shouldUpdateTransactionData = false

    if (this.props.isPersonalDisabled && targetFlowType === 'send') {
      return handleInterstitialCipFlow(targetFlowType)
    }
    if (this.props.isPurchaseDisabled && targetFlowType === 'buy') {
      return handleInterstitialCipFlow(targetFlowType)
    }

    // the handleClose is closely coupled to send flow
    // this is hack for other flows so that we do not need to do the routing
    if (this.props.handleCloseForOtherFlow) {
      return this.handleCloseForOtherFlow(targetFlowType)
    }

    const url =
      this.props.flowType !== 'payRequest'
        ? paymentTypeUrlMap[targetFlowType]
        : 'payRequest'

    if (this.props.flowType === 'payRequest') {
      if (!this.props.paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = this.props.isPurchase ? 'buy' : 'send'
        if (preFlowType !== targetFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }
    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      this.url = url
      this.targetFlowType = targetFlowType
      shouldUpdateTransactionData = true
      trackClickUnifiedSend('continue')
    }

    this.props.dispatch(ViewActions.setPaymentTypeSelected(true))

    this.props.handleClose(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  selectInput = purchaseType => {
    trackClickUnifiedSend(purchaseType)
    this.setState({
      isPurchase: purchaseType === 'selectGS',
      radioValue: purchaseType === 'selectGS' ? 'goods' : 'personal',
    })
  }

  render() {
    const { radioValue } = this.state
    const hideContent = {
      opacity: '0',
      display: 'none',
    }

    const showContent = {
      opacity: '1',
      display: 'block',
    }

    const showContentImg = {
      opacity: '1',
      display: 'block',
      margin: '0 auto',
    }

    const sendTypeGoods = (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <div data-nemo="gscard">
            <IconWrapper isMobile={matches}>
              <Spot
                name="insured"
                role="presentation"
                data-testid="ppShield"
                id="ppShield"
                style={radioValue === 'goods' ? showContentImg : hideContent}
                ref={img => (this.ppShield = img)}
                size="lg"
              />
            </IconWrapper>
            <BodyText as={TitleText} strong>
              {i18nPaymentType('goods.v1Title')}
            </BodyText>
            {matches ? (
              <CaptionText>
                {i18nPaymentType('goods.v1Description')}
              </CaptionText>
            ) : (
              <BodyText>{i18nPaymentType('goods.v1Description')}</BodyText>
            )}
          </div>
        )}
      </Media>
    )
    const sendTypePersonal = (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <div data-nemo="ffcard">
            <BodyText
              style={{ marginBottom: radioValue === 'personal' ? '0.5rem' : 0 }}
              strong
            >
              {i18nPaymentType('personal.v1Title')}
            </BodyText>
            {matches ? (
              <CaptionText
                style={radioValue === 'personal' ? showContent : hideContent}
              >
                {i18nPaymentType('personal.v1Description')}
              </CaptionText>
            ) : (
              <BodyText
                style={radioValue === 'personal' ? showContent : hideContent}
              >
                {i18nPaymentType('personal.v1Description')}
              </BodyText>
            )}
          </div>
        )}
      </Media>
    )
    return (
      <PaymentTypesToggle data-nemo="t3-variant" tabIndex="-1">
        <SingleSelectionGroup
          name="sendType"
          secondary
          label={i18nPaymentType('main.chooseAPaymentType')}
          hideLabel={true}
          onChange={e => this.selectInput(e.target.value)}
          align="center"
          className="send-type-goods-personal"
          options={[
            {
              label: sendTypeGoods,
              id: 'sendTypeGoods',
              value: 'selectGS',
              'data-testid': 'purchase',
              checked: radioValue === 'goods',
            },
            {
              label: sendTypePersonal,
              id: 'sendTypePersonal',
              value: 'selectFF',
              'data-testid': 'personal',
              checked: radioValue === 'personal',
            },
          ]}
        />
        <CaptionText className="learnMore">
          {i18nPaymentType('main.learnMore', {
            purchaseProtectionLink: <PurchaseProtection />,
          })}
        </CaptionText>
        <Button
          data-nemo="continue-btn"
          onClick={this.handleSubmit}
          className="ctaButton"
        >
          {i18nPaymentType('main.continue')}
        </Button>
      </PaymentTypesToggle>
    )
  }
}
PaymentTypeChoice.propTypes = {
  /** this is redux dispatch */
  dispatch: PropTypes.func.isRequired,
  flowType: PropTypes.string,
  handleClose: PropTypes.func,
  handleCloseForOtherFlow: PropTypes.func,
  isGuest: PropTypes.bool,
  hasSelectedFundingOption: PropTypes.bool,
  triggerSenderPhoneConfirmation: PropTypes.bool,
  amount: PropTypes.any,
  currencyCode: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  displayName: PropTypes.string,
  recipient: PropTypes.string,
  payerId: PropTypes.string,
  isPurchase: PropTypes.bool,
  paymentTypeIsSelected: PropTypes.bool,
  isPersonalDisabled: PropTypes.bool,
  isPurchaseDisabled: PropTypes.bool,
  cdnHostName: PropTypes.string,
}

export default connect(({ server, transaction, recipient, amount, user }) => ({
  transaction: transaction.isPurchase,
  triggerSenderPhoneConfirmation:
    server.triggerSenderPhoneConfirmation ||
    user.triggerSenderPhoneConfirmation,
  displayName: recipient.displayName,
  thumbnailUrl: recipient.thumbnailUrl,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  recipient: recipient.recipient,
  payerId: recipient.payerId,
  isPurchase: transaction.isPurchase,
  paymentTypeIsSelected: transaction.paymentTypeIsSelected,
  isPersonalDisabled: user.isPersonalDisabled,
  isPurchaseDisabled: user.isPurchaseDisabled,
  cdnHostName: server.cdnHostName,
}))(PaymentTypeChoice)
